import { Controller } from "@hotwired/stimulus"
import * as bootstrap from "bootstrap"

export default class extends Controller {
  connect() {
    if(this.element.getAttribute('closed') !== 'true') {
      const modalElement = this.element.closest(".modal")
      if (modalElement) {
        const modal = bootstrap.Modal.getOrCreateInstance(modalElement)
        modalElement.addEventListener('hidden.bs.modal', event => {
          this.element.innerHTML = ''
          this.element.setAttribute('closed', 'true')
        })
        modal.toggle()
      }
    }
  }
}
